module.exports = __webpack_public_path__ + "img/中華電信HINET.3677e17e.png";